/* ============================================
   VIDEO SECTION - Fullscreen Functionality
   ============================================ */

   (function() {
    let overlay = null;
    let closeBtn = null;
    let escHandler = null;
    
    const addAutoplay = (url) => url + (url.includes('?') ? '&autoplay=1' : '?autoplay=1');
    
    const cleanup = () => {
      if (escHandler) {
        document.removeEventListener('keydown', escHandler);
        escHandler = null;
      }
      if (closeBtn) {
        closeBtn.remove();
        closeBtn = null;
      }
      if (overlay) {
        overlay.remove();
        overlay = null;
      }
    };
    
    const getVideoSource = (button) => {
      const customSrc = button.getAttribute('data-fullscreen-video-src');
      if (customSrc) return customSrc;
      
      const section = button.closest('.shopify-section--video');
      if (!section) return null;
      
      const videoMedia = section.querySelector('video-media');
      if (!videoMedia) return null;
      
      const video = videoMedia.querySelector('video') || videoMedia.querySelector('iframe');
      if (!video) return null;
      
      return video.tagName === 'VIDEO' ? (video.src || video.querySelector('source')?.src) : video.src;
    };
    
    const createVideoElement = (src) => {
      const isExternal = src.includes('youtube.com') || src.includes('vimeo.com');
      
      if (isExternal) {
        const iframe = document.createElement('iframe');
        iframe.className = 'video-page-fullscreen-overlay__iframe';
        iframe.src = addAutoplay(src);
        iframe.allow = 'autoplay; encrypted-media';
        iframe.allowFullscreen = true;
        return iframe;
      }
      
      const video = document.createElement('video');
      video.className = 'video-page-fullscreen-overlay__video';
      video.src = src;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      return video;
    };
    
    document.addEventListener('click', (e) => {
      const button = e.target.closest('[data-video-fullscreen]');
      if (!button) return;
      
      e.preventDefault();
      cleanup();
      
      const videoSrc = getVideoSource(button);
      if (!videoSrc) return;
      
      // Create overlay
      overlay = document.createElement('div');
      overlay.className = 'video-page-fullscreen-overlay active';
      
      const container = document.createElement('div');
      container.className = 'video-page-fullscreen-overlay__container';
      container.appendChild(createVideoElement(videoSrc));
      
      // Create close button
      closeBtn = document.createElement('button');
      closeBtn.className = 'video-page-fullscreen-overlay__close';
      closeBtn.type = 'button';
      closeBtn.innerHTML = '×';
      closeBtn.setAttribute('aria-label', 'Close fullscreen video');
      closeBtn.onclick = cleanup;
      
      // Add to DOM
      overlay.appendChild(container);
      document.body.appendChild(overlay);
      document.body.appendChild(closeBtn);
      
      // ESC key support
      escHandler = (e) => e.key === 'Escape' && cleanup();
      document.addEventListener('keydown', escHandler);
    });
  })();
  
  /* ============================================
     END: VIDEO SECTION
     ============================================ */
  
  /* ============================================
     PRODUCT GALLERY - Side Arrows Initial State
     ============================================ */
  
  /**
   * Set initial disabled state for product gallery side arrows
   * Ensures left arrow is disabled on first slide at page load
   */
  (function() {
    const initArrowsState = () => {
      const galleries = document.querySelectorAll('.product-gallery--side-arrows');
      
      galleries.forEach(gallery => {
        const carousel = gallery.querySelector('media-carousel');
        const sideArrows = gallery.querySelector('.product-gallery__side-arrows');
        
        if (!carousel || !sideArrows) return;
        
        const prevButton = sideArrows.querySelector('[is="prev-button"]');
        const nextButton = sideArrows.querySelector('[is="next-button"]');
        
        if (!prevButton || !nextButton) return;
        
        // Get current index and total items
        const currentIndex = carousel.selectedIndex || 0;
        const totalItems = carousel.items.length;
        
        // Set initial disabled state
        if (currentIndex === 0) {
          prevButton.disabled = true;
        }
        if (currentIndex === totalItems - 1) {
          nextButton.disabled = true;
        }
      });
    };
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initArrowsState);
    } else {
      // DOM already loaded
      initArrowsState();
    }
    
    // Support for theme editor
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', initArrowsState);
    }
  })();
  
  /* ============================================
     END: PRODUCT GALLERY
     ============================================ */
  
  /* ============================================
     BLOG DROPDOWN FILTER
     ============================================ */
  
  /**
   * Blog dropdown filter functionality for recipe pages
   */
  (function() {
    let dropdownListButtons = document.querySelectorAll('.dropdown-list .dropdown-list_btn');
    if (dropdownListButtons.length > 0) {
      dropdownListButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          let dropdownContent = this.nextElementSibling;
          let dropdownContentDisplay = dropdownContent.style.display;
          let dropdownListContent = document.querySelectorAll('.dropdown-list .dropdown-list_content');
          if (dropdownListContent) {
            dropdownListContent.forEach(function (content) {
              content.style.display = 'none';
            });
          }
          dropdownContent.style.display = dropdownContentDisplay === 'block' ? 'none' : 'block';
          event.stopPropagation();
        });
      });
    }
    
    let dropdownListItems = document.querySelectorAll('.dropdown-list .dropdown-list_item');
    if (dropdownListItems.length > 0) {
      dropdownListItems.forEach(function (item) {
        item.addEventListener('click', function (event) {
          let value = event.target.dataset.value;
          let labelElement = event.target.closest('.dropdown-list').querySelector('.dropdown-list_btn span');
          let optionalFirst = event.target.textContent;
          labelElement.textContent = optionalFirst;
          let find = "/blogs/recipes/tagged/" + value;
          window.location.href = find;
        });
      });
    }
    
    document.addEventListener('click', function() {
      if (document.querySelectorAll('.dropdown-list_content')) {
        document.querySelectorAll('.dropdown-list_content').forEach(function(content) {
          content.style.display = 'none';
        });
      }
    });
  })();
  
  /* ============================================
     END: BLOG DROPDOWN FILTER
     ============================================ */
  
  /* ============================================
     REZEPTE SEARCH
     ============================================ */

document.addEventListener('DOMContentLoaded', function() {
  // recipe animation start
  const recipeAnimation = document.getElementsByClassName('v-recipe-animation');
  if (recipeAnimation.length > 0) {
    const recipeCoverImage = document.querySelector('.v-recipe-animation .cover-image');
    const recipeCoverButton = document.querySelector('.v-recipe-animation .cover-button');
    const recipePick = document.querySelector('.v-recipe-animation .recipe-pick');
    recipeCoverButton.addEventListener('click', function() {
      recipeCoverImage.style.display = 'none';
      recipePick.style.display = 'flex';
      setTimeout(function() {
        recipePick.classList.add('show');
      }, 10);
    });
    let shakeTimer = null;
    let glowTimer = null;
    const recipePickFirst = document.querySelector('.v-recipe-animation .pick-first');
    const recipePickSecond = document.querySelector('.v-recipe-animation .pick-second');
    const recipeFirst = document.querySelector('.v-recipe-animation .recipe-first');
    const recipeSecond = document.querySelector('.v-recipe-animation .recipe-second');
    const recipeStep1 = document.querySelectorAll('.v-recipe-animation .step-1');
    const recipeStep2 = document.querySelectorAll('.v-recipe-animation .step-2');
    const recipeStep3 = document.querySelectorAll('.v-recipe-animation .step-3');
    recipePickFirst.addEventListener('click', function() {
      recipePick.style.display = 'none';
      recipeFirst.style.display = 'flex';
      recipeSecond.style.display = 'none';
      recipeStep1[0].style.display = 'flex';
      addShakeEffect('.img-food1, .img-food2');
      setTimeout(function() {
        recipeStep1[0].classList.add('show');
      }, 10);
    });
    recipePickSecond.addEventListener('click', function() {
      recipePick.style.display = 'none';
      recipeFirst.style.display = 'none';
      recipeSecond.style.display = 'flex';
      recipeStep1[1].style.display = 'flex';
      addShakeEffect('.img-food1, .img-food2, .img-food3');
      setTimeout(function() {
        recipeStep1[1].classList.add('show');
      }, 10);
    });
    function flyToCenter(img) {
      if (img.classList.contains('has-flown')) return;
      const parent = img.closest('.step-1');
      const parentRect = parent.getBoundingClientRect();
      const imgRect = img.getBoundingClientRect();
    
      // 计算中心点
      const centerX = parentRect.left + parentRect.width / 2;
      const centerY = parentRect.top + parentRect.height / 2;
    
      // 计算图片中心到父容器中心的偏移
      const deltaX = centerX - (imgRect.left + imgRect.width / 2);
      const deltaY = centerY - (imgRect.top + imgRect.height / 2);
    
      // 抛物线顶点（可调整，y方向负值表示向上弯曲）
      const yMiddle = deltaY - 80;
    
      // 设置自定义属性
      img.style.setProperty('--x', deltaX + 'px');
      img.style.setProperty('--y-middle', yMiddle + 'px');
      img.style.setProperty('--center-x', deltaX + 'px');
      img.style.setProperty('--center-y', deltaY + 'px');
    
      // 添加动画 class
      img.classList.add('fly-to-center');
      img.classList.add('has-flown');
    
      // 动画结束后隐藏图片
      img.addEventListener('animationend', function handler() {
        img.style.opacity = 0;
        img.classList.remove('fly-to-center');
        img.removeEventListener('animationend', handler);
      });
    }
    function addShakeEffect(selector) {
      if (shakeTimer) clearInterval(shakeTimer);
    
      shakeTimer = setInterval(() => {
        document.querySelectorAll(selector).forEach(img => {
          // 只对未飞走的元素抖动
          if (!img.classList.contains('has-flown')) {
            img.classList.add('shake-animate');
            img.addEventListener('animationend', function handler() {
              img.classList.remove('shake-animate');
              img.removeEventListener('animationend', handler);
            });
          }
        });
      }, 3000);
    }
    function allImgFoodClickedIn(containerSelector) {
      const container = document.querySelector(containerSelector);
      if (!container) return false;
      const imgs = container.querySelectorAll('.img-food1, .img-food2, .img-food3');
      if (imgs.length === 0) return false;
      return Array.from(imgs).every(img => img.classList.contains('has-flown'));
    }
    function addGlowEffect(selector) {
      if (glowTimer) clearInterval(glowTimer);
      glowTimer = setInterval(() => {
        document.querySelectorAll(selector).forEach(img => {
          img.classList.add('glow-animate');
          img.addEventListener('animationend', function handler() {
            img.classList.remove('glow-animate');
            img.removeEventListener('animationend', handler);
          });
        });
      }, 3000);
    }
    ['img-food1', 'img-food2', 'img-food3'].forEach(cls => {
      document.querySelectorAll('.' + cls).forEach(img => {
        img.addEventListener('click', function() {
          flyToCenter(img);
          if (recipeFirst.style.display === 'flex') {
            if (allImgFoodClickedIn('.recipe-first')) {
              setTimeout(function() {
                recipeStep1[0].style.display = 'none';
                recipeStep2[0].style.display = 'flex';
                addGlowEffect('.img-paly-button');
                if (shakeTimer) {
                  clearInterval(shakeTimer);
                  shakeTimer = null;
                }
                setTimeout(function() {
                  recipeStep2[0].classList.add('show');
                }, 10);
              }, 1000)
            }
          } else {
            if (allImgFoodClickedIn('.recipe-second')) {
              setTimeout(function() {
                recipeStep1[1].style.display = 'none';
                recipeStep2[1].style.display = 'flex';
                addGlowEffect('.img-paly-button');
                if (shakeTimer) {
                  clearInterval(shakeTimer);
                  shakeTimer = null;
                }
                setTimeout(function() {
                  recipeStep2[1].classList.add('show');
                }, 10);
              }, 1000)
            }
          }
        });
      });
    });
    // img-paly-button
    const imgPalyButton = document.querySelectorAll('.v-recipe-animation .img-paly-button');
    const recipeStepLoading = document.querySelectorAll('.v-recipe-animation .step-loading');
    const loadingSuccess = document.querySelectorAll('.v-recipe-animation .loading-success');
    imgPalyButton.forEach((button, index) => {
      button.addEventListener('click', function() {
        recipeStep2[index].style.display = 'none';
        if (glowTimer) {
          clearInterval(glowTimer);
          glowTimer = null;
        }
        recipeStepLoading[index].style.display = 'flex';
        setTimeout(function() {
          recipeStepLoading[index].classList.add('show');
        }, 10);
        
        // progress bar start
        const progressBar = document.querySelectorAll('.v-recipe-animation .progress-bar');
        progressBar[index].style.width = '0%';
        setTimeout(() => {
          progressBar[index].style.width = '100%';
        }, 10); 
        setTimeout(() => {
          recipeStepLoading[index].style.display = 'none';
          recipeStep3[index].style.display = 'flex';
          setTimeout(function() {
            recipeStep3[index].classList.add('show');
            loadingSuccess[index].style.display = 'flex';
            setTimeout(function() {
              loadingSuccess[index].style.display = 'none';
            },1000);
          }, 10);
        }, 2010);
      });
    });
    // summer-restart-button
    const summerRestartButton = document.querySelectorAll('.v-recipe-animation .summer-restart-button');
    summerRestartButton.forEach((button, index) => {
      button.addEventListener('click', function() {
        let indexFlag = index == 0 || index == 1 ? 0 : 1;
        recipeStep3[indexFlag].style.display = 'none';
        recipeCoverImage.style.transform = 'translateY(-600px)';
        recipeCoverImage.style.display = 'flex';
        setTimeout(function() {
          recipeCoverImage.style.transform = 'translateY(0)';
          recipeCoverImage.classList.add('slide-down');
          resetAllSummerState()
        }, 10);
      });
    });
    // recipe copy button start
    const recipeCopyButton = document.querySelectorAll('.v-recipe-animation .recipe-copy-button-pc');
    recipeCopyButton.forEach((button, index) => {
      button.addEventListener('click', function() {
        const couponCode = button.getAttribute('data-coupon-code')
        navigator.clipboard.writeText(couponCode);
        let tips = document.getElementsByClassName('step-3-tips')[index];

        tips.style.display = 'block';
        setTimeout(function() {
          tips.classList.add('show');
        }, 10);

        setTimeout(function() {
          tips.classList.remove('show');
          setTimeout(function() {
            tips.style.display = 'none';
          }, 400);
        }, 1500);
      });
    });

    // recipe share button start
    const recipeShareButton = document.querySelectorAll('.v-recipe-animation .recipe-share-button-pc');
    const popup = document.querySelectorAll('.v-recipe-animation .share-popup-buttons-pc');
    recipeShareButton.forEach((button, index) => {
      button.addEventListener('mouseenter', () => {
        popup[index].style.display = 'flex';
      });
      button.addEventListener('mouseleave', () => {
        popup[index].style.display = 'none';
      });

      const shareURL = encodeURIComponent(window.location.href);
      const shareText = encodeURIComponent('この素晴らしいコンテンツをチェックしてください！');
      // Pinterest
      // const pinterestURL = 'https://pinterest.com/pin/create/button/?url=' + shareURL + '&description=' + shareText;
      // shareMethod(document.getElementById('share-pinterest'), pinterestURL, 'pinterest');
      // Line
      const lineURL = 'https://line.me/R/msg/text/?' + shareText;
      const shareLine = document.querySelectorAll('.v-recipe-animation .share-line');
      shareLine.forEach(button => {
        button.addEventListener('click', function() {
          window.open(lineURL, 'line-share-dialog', 'width=800,height=600');
        });
      });
      // Facebook
      const facebookURL = 'https://www.facebook.com/sharer/sharer.php?u=' + shareURL;
      const shareFacebook = document.querySelectorAll('.v-recipe-animation .share-facebook');
      shareFacebook.forEach(button => {
        button.addEventListener('click', function() {
          window.open(facebookURL, 'facebook-share-dialog', 'width=800,height=600');
        });
      });
      // X
      const twitterURL = 'https://twitter.com/intent/tweet?url=' + shareURL + '&text=' + shareText;
      const shareX = document.querySelectorAll('.v-recipe-animation .share-x');
      shareX.forEach(button => {
        button.addEventListener('click', function() {
          window.open(twitterURL, 'twitter-share-dialog', 'width=800,height=600');
        });
      });
    });
    // mobile popup start
    const mobilePopup = document.querySelectorAll('.v-recipe-animation .food-mobile-popup');
    const mobileCouponText = document.querySelectorAll('.v-recipe-animation .coupon-text-mobile');
    const mobileCouponCopyButton = document.querySelectorAll('.v-recipe-animation .step-3-box-mobile .recipe-copy-button-mobile');
    const mobileShareButton = document.querySelectorAll('.v-recipe-animation .step-3-box-mobile .recipe-share-button-mobile');
    const mobilePopupCouponClose = document.querySelectorAll('.v-recipe-animation .food-mobile-popup-close');
    const mobilePopupCouponCloseText = document.querySelectorAll('.v-recipe-animation .food-mobile-popup-close-text');
    const mobilePopupCouponCloseShare = document.querySelectorAll('.v-recipe-animation .food-mobile-popup-close-share');
    const mobilePopupCopyTips = document.querySelectorAll('.v-recipe-animation .food-mobile-popup .step-3-tips-mobile');
    const mobilePopupCouponText = document.querySelectorAll('.v-recipe-animation .food-mobile-popup .coupon-text');
    const mobilePopupShareButtons = document.querySelectorAll('.v-recipe-animation .food-mobile-popup .share-popup-buttons');
    mobileCouponText.forEach((text, index) => {
      text.addEventListener('click', function() {
        mobilePopup[index].style.display = 'flex';
        mobilePopupCouponText[index].style.display = 'block';
        mobilePopupCouponCloseText[index].style.display = 'flex';
      });
    });
    mobileCouponCopyButton.forEach((button, index) => {
      button.addEventListener('click', function() {
        const couponCode = button.getAttribute('data-coupon-code')
        navigator.clipboard.writeText(couponCode);
        mobilePopup[index].style.display = 'flex';
        mobilePopupCopyTips[index].style.display = 'flex';
        mobilePopupCouponCloseText[index].style.display = 'flex';
      });
    });
    mobileShareButton.forEach((button, index) => {
      button.addEventListener('click', function() {
        mobilePopup[index].style.display = 'flex';
        mobilePopupShareButtons[index].style.display = 'flex';
        mobilePopupCouponCloseShare[index].style.display = 'flex';
      });
    });
    mobilePopupCouponClose.forEach((close, index) => {
      close.addEventListener('click', function() {
        let indexFlag = index == 0 || index == 1 ? 0 : 1;
        mobilePopup[indexFlag].style.display = 'none';
        mobilePopupCouponText[indexFlag].style.display = 'none';
        mobilePopupCopyTips[indexFlag].style.display = 'none';
        mobilePopupShareButtons[indexFlag].style.display = 'none';
        mobilePopupCouponCloseText[indexFlag].style.display = 'none';
        mobilePopupCouponCloseShare[indexFlag].style.display = 'none';
      });
    });
  }
  function resetAllSummerState() {
    document.querySelector('.v-recipe-animation .recipe-pick').classList.remove('show');
    document.querySelector('.v-recipe-animation .recipe-pick').style.display = 'none';

    document.querySelector('.v-recipe-animation .recipe-first').style.display = 'none';
    document.querySelector('.v-recipe-animation .recipe-second').style.display = 'none';
    
    document.querySelectorAll('.step-1, .step-2, .step-3').forEach(el => {
      el.style.display = 'none';
      el.classList.remove('show');
    });
    document.querySelectorAll('.v-recipe-animation .step-loading').forEach(el => {
      el.style.display = 'none';
      el.classList.remove('show');
    });

    document.querySelectorAll('.img-food1, .img-food2, .img-food3').forEach(img => {
      img.style.opacity = 1;
      img.classList.remove('has-flown', 'fly-to-center', 'shake-animate', 'glow-animate');
      img.removeAttribute('data-flying');
    });

    document.querySelectorAll('.progress-bar').forEach(bar => {
      bar.style.width = '0%';
    });

    document.querySelectorAll('.step-3-tips, .step-3-tips-mobile').forEach(el => {
      el.style.display = 'none';
    });

    if (typeof addShakeEffect === 'function') addShakeEffect('.img-food1, .img-food2, .img-food3');
    if (typeof addGlowEffect === 'function') addGlowEffect('.img-paly-button');
  }
  // recipe animation end

    
  /**
   * Recipe search functionality
   */
  const searchForm = document.getElementById('main-search-form');
  const pathname = window.location.pathname;
  
  if (searchForm && pathname.includes('/blogs/recipes')) {
    const urlObj = new URL(window.location.href);
    const params = new URLSearchParams(urlObj.search);
    const qValue = params.get('vs');
    const vsInput = document.querySelector('input[name="vs"]');
    
    if (vsInput) {
      vsInput.value = qValue || '';
    }
    
    if (qValue) {
      const recipeContainer = document.querySelector('.blog-recipe__container');
      if (recipeContainer) {
        recipeContainer.innerHTML = '';
      }
      
      let paginationPoints = document.querySelectorAll('.pagination-point');
      if (paginationPoints) {
        paginationPoints.forEach(function(element) {
          element.style.display = 'none';
        });
      }
      
      let searchQuery = qValue;
      if (pathname.includes('/blogs/recipes/tagged/')) {
        let searchTag = pathname.split('tagged/')[1];
        searchQuery = searchQuery + ' tag:' + searchTag;
      }
      
      fetch('/search?q=' + encodeURIComponent(searchQuery) + '&type=article&options[prefix]=last')
        .then(function (response) {
          return response.text();
        })
        .then(function (data) {
          const html = new DOMParser().parseFromString(data, 'text/html');
          const targetElement = document.querySelector('.blog-recipe__container');
          const sourceElement = html.querySelector('.blog-recipe__container');

          if (targetElement && sourceElement) {
            var items = sourceElement.querySelectorAll('.recipe-article-content');
            items.forEach(function(item) {
              var onclickAttr = item.getAttribute('onclick') || '';
              if (!onclickAttr.includes('/blogs/recipes/')) {
                item.remove();
              }
            });

            var remaining = sourceElement.querySelectorAll('.recipe-article-content');
            if (remaining.length === 0) {
              targetElement.innerHTML = '<div class="empty-state"><div class="prose"><h1 class="h4">No results found.</h1></div></div>';
            } else {
              targetElement.replaceWith(sourceElement);
            }
          } else if (targetElement && !!qValue) {
            targetElement.innerHTML = '<div class="empty-state"><div class="prose"><h1 class="h4">No results found.</h1></div></div>';
          }
        });
    }
    
    searchForm.addEventListener('submit', function (event) {
      event.preventDefault();
      let searchQuery = document.querySelector('input[name="vs"]').value;

      if (searchQuery) {
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.set('vs', searchQuery);
        var newUrl = window.location.pathname + '?' + searchParams.toString();
        window.location.href = newUrl;
      } else {
        window.location.href = window.location.pathname;
      }
    });
  }

/* ============================================
   END: REZEPTE SEARCH
   ============================================ */
})

/* Countdown module (migrated from assets/countdown.js) */
;(function() {
  'use strict'

  function clampToZero(n) { return n < 0 ? 0 : n }
  function pad2(n) { var v = Math.floor(clampToZero(n)); return v < 10 ? '0' + v : String(v) }
  function normalizeOffsetColon(tz) { return tz.replace(/([+-]\d{2})(\d{2})$/, '$1:$2') }
  function ensureIsoWithTz(input) {
    if (!input) return null
    var s = String(input).trim(); if (!s) return null
    s = s.replace(/\//g, '-'); s = s.replace(' ', 'T')
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) s += 'T00:00:00'
    if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(s)) s += '+09:00'; else s = s.replace(/([+-]\d{2})(\d{2})$/, normalizeOffsetColon('$1$2'))
    return s
  }

  function TimeCalculator() {}
  TimeCalculator.prototype.parse = function(input) {
    var iso = ensureIsoWithTz(input); if (!iso) return null
    var d = new Date(iso); if (isNaN(d.getTime())) return null
    return d
  }
  TimeCalculator.prototype.diff = function(target, now) {
    var ms = target.getTime() - now.getTime(); ms = Math.max(0, ms)
    var totalSeconds = Math.floor(ms / 1000)
    var days = Math.floor(totalSeconds / 86400)
    var hours = Math.floor((totalSeconds % 86400) / 3600)
    var minutes = Math.floor((totalSeconds % 3600) / 60)
    var seconds = totalSeconds % 60
    return { days: days, hours: hours, minutes: minutes, seconds: seconds, ms: ms }
  }

  function DOMUpdater(root) { this.root = root }
  DOMUpdater.prototype.setValues = function(values, leading) {
    var dd = this.root.querySelector('[data-dd]')
    var hh = this.root.querySelector('[data-hh]')
    var mm = this.root.querySelector('[data-mm]')
    var ss = this.root.querySelector('[data-ss]')

    function setIfChanged(el, nextText) {
      if (!el) return
      var text = String(nextText)
      if (el.textContent !== text) {
        el.textContent = text
      }
    }

    setIfChanged(dd, leading ? pad2(values.days) : String(values.days))
    setIfChanged(hh, leading ? pad2(values.hours) : String(values.hours))
    setIfChanged(mm, leading ? pad2(values.minutes) : String(values.minutes))
    setIfChanged(ss, leading ? pad2(values.seconds) : String(values.seconds))
  }
  DOMUpdater.prototype.showCompleteText = function(text) {
    this.root.innerHTML = '<span class="v-countdown__complete-text">' + (text || '') + '</span>'
  }
  DOMUpdater.prototype.hide = function() { this.root.style.display = 'none' }
  DOMUpdater.prototype.zero = function(leading) { this.setValues({ days: 0, hours: 0, minutes: 0, seconds: 0 }, leading) }

  function CountdownComponent(el, options) {
    this.el = el; this.options = options || {}
    this.tc = new TimeCalculator(); this.updater = new DOMUpdater(el)
    this._interval = null; this._target = null
  }
  CountdownComponent.prototype.init = function() {
    var targetStr = this.options.target || this.el.getAttribute('data-target') || ''
    var tzTarget = this.tc.parse(targetStr)
    if (!tzTarget) {
      var invalidText = this.options.invalidText || this.el.getAttribute('data-invalid-text') || 'Invalid date'
      this.el.innerHTML = invalidText; return false
    }
    this._target = tzTarget; this.render()
    var self = this; this._interval = setInterval(function() { self.render() }, 1000)
    return true
  }
  CountdownComponent.prototype.pause = function() { if (this._interval) { clearInterval(this._interval); this._interval = null } }
  CountdownComponent.prototype.resume = function() {
    var self = this; if (!this._target) return; if (this._interval) return
    this.render(); this._interval = setInterval(function() { self.render() }, 1000)
  }
  CountdownComponent.prototype.render = function() {
    var leading = this.options.leadingZero != null ? this.options.leadingZero : (this.el.getAttribute('data-leading-zero') === 'true')
    var behavior = this.options.completeBehavior || this.el.getAttribute('data-complete-behavior') || 'hide'
    var completeText = this.options.completeText || this.el.getAttribute('data-complete-text') || ''
    var diff = this.tc.diff(this._target, new Date())
    if (diff.ms <= 0) {
      this.destroy(); if (behavior === 'text' && completeText) this.updater.showCompleteText(completeText)
      else if (behavior === 'hide') this.updater.hide(); else this.updater.zero(leading); return
    }
    this.updater.setValues(diff, leading)
  }
  CountdownComponent.prototype.destroy = function() { if (this._interval) { clearInterval(this._interval); this._interval = null } }

  var Registry = (function() {
    var instances = new Set()
    function isManaged(el) { return !!(el.__vCc || el.__vCountdownInterval) }
    function attach(el) { if (!el || isManaged(el)) return null; var comp = new CountdownComponent(el, {}); if (!comp.init()) return null; el.__vCc = comp; instances.add(comp); return comp }
    function initAllIn(root) { var scope = root || document; var els = scope.querySelectorAll('[data-countdown]'); els.forEach(function(el){ attach(el) }) }
    function destroyAllIn(root) { var scope = root || document; var els = scope.querySelectorAll('[data-countdown]'); els.forEach(function(el){ if (el.__vCc) { el.__vCc.destroy(); instances.delete(el.__vCc); el.__vCc = null } }) }
    function pauseAll() { instances.forEach(function(c){ c.pause() }) }
    function resumeAll() { instances.forEach(function(c){ c.resume() }) }
    return { attach: attach, initAllIn: initAllIn, destroyAllIn: destroyAllIn, pauseAll: pauseAll, resumeAll: resumeAll }
  })()

  function onDomReady(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn() }
  onDomReady(function(){ if (window.VCountdownModule && window.VCountdownModule.autoInit === false) return; try { Registry.initAllIn(document) } catch (e) {} })
  document.addEventListener('visibilitychange', function(){ try { if (document.hidden) Registry.pauseAll(); else Registry.resumeAll() } catch (e) {} })
  window.addEventListener('beforeunload', function(){ try { Registry.destroyAllIn(document) } catch (e) {} })
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e){ try { if (!e || !e.detail || !e.detail.sectionId) return; var root = document.getElementById('shopify-section-' + e.detail.sectionId); if (root) Registry.initAllIn(root) } catch (err) {} })
    document.addEventListener('shopify:section:unload', function(e){ try { if (!e || !e.detail || !e.detail.sectionId) return; var root = document.getElementById('shopify-section-' + e.detail.sectionId); if (root) Registry.destroyAllIn(root) } catch (err) {} })
  }

  window.VCountdownModule = { TimeCalculator: TimeCalculator, DOMUpdater: DOMUpdater, CountdownComponent: CountdownComponent, Registry: Registry, autoInit: true }
})()

/* Anchor navigation module */
;(function(){
  'use strict'

  function qsa(scope, sel){ return Array.prototype.slice.call((scope||document).querySelectorAll(sel)) }
  function on(el, type, handler){ if (el) el.addEventListener(type, handler, { passive: true }) }

  function getStickyOffset(nav){
    try {
      if (nav.getAttribute('data-sticky') !== 'true') return 0
      var top = getComputedStyle(nav).top
      var n = parseInt(top, 10)
      return isNaN(n) ? 0 : n
    } catch(e){ return 0 }
  }

  function smoothScrollTo(y){
    try { window.scrollTo({ top: y, behavior: 'smooth' }) }
    catch(e){ window.scrollTo(0, y) }
  }

  function scrollToId(id, offset){
    var el = document.getElementById(id)
    if (!el) return false
    var rect = el.getBoundingClientRect()
    var extraOffset = 0
    try {
      var computed = getComputedStyle(el)
      var scrollMarginTop = computed.scrollMarginTop
      if (scrollMarginTop && scrollMarginTop !== 'auto') {
        var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0
        var totalMargin = parseFloat(scrollMarginTop)
        extraOffset = totalMargin - headerHeight
      }
    } catch(e) {}
    var top = rect.top + window.pageYOffset - (offset || 0) - extraOffset
    smoothScrollTo(top)
    return true
  }

  function initAnchorNav(root){
    var container = root || document
    var navs = qsa(container, '.v-anchor-navigation')
    if (!navs.length) return

    navs.forEach(function(nav){
      if (nav.__vAnchorInit) return; nav.__vAnchorInit = true

      var smooth = String(nav.getAttribute('data-smooth')) === 'true'
      var links = qsa(nav, '.v-anchor-navigation__link')
      if (!links.length) return

      var stickyTop = getStickyOffset(nav)

      // clicks
      var lockTargetId = null
      function unlockWhenArrived(targetEl){
        if (!targetEl) { lockTargetId = null; return }
        var tries = 0
        ;(function tick(){
          var expected = getDocTop(targetEl) - stickyTop
          var at = Math.abs(window.pageYOffset - expected) <= 2
          if (at || tries > 300) { lockTargetId = null; recomputeActiveByScroll(); return }
          tries++; requestAnimationFrame(tick)
        })()
      }

      links.forEach(function(a){
        a.addEventListener('click', function(e){
          var id = a.getAttribute('data-anchor') || ''
          if (!id) return
          if (smooth) e.preventDefault()
          var ok = scrollToId(id, stickyTop)
          if (smooth && ok) { lockTargetId = id; setActive(id); unlockWhenArrived(document.getElementById(id)) }
          // Do not modify URL hash when smooth scrolling is enabled
        }, { passive: false })
      })

      // active state
      var activeClass = 'is-active'
      function setActive(id){
        var activeLink = null
        links.forEach(function(a){
          var isActive = id && (a.getAttribute('data-anchor') === id)
          a.classList.toggle(activeClass, isActive)
          if (isActive) {
            a.setAttribute('aria-current', 'location')
            activeLink = a
          } else {
            a.removeAttribute('aria-current')
          }
        })
        
        // Center active item when navigation has overflow
        if (activeLink && list && list.scrollWidth > list.clientWidth) {
          scrollActiveToCenter(activeLink)
        }
      }

      // Scroll active item to center of navigation
      function scrollActiveToCenter(activeLink) {
        if (!activeLink || !list) return
        
        var linkRect = activeLink.getBoundingClientRect()
        var listRect = list.getBoundingClientRect()
        
        // Calculate the position of the link relative to the list container
        var linkCenterX = linkRect.left + linkRect.width / 2 - listRect.left + list.scrollLeft
        var listCenterX = list.clientWidth / 2
        
        // Calculate target scroll position to center the active item
        var targetScrollLeft = linkCenterX - listCenterX
        
        // Clamp to valid scroll range
        targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, list.scrollWidth - list.clientWidth))
        
        // Smooth scroll to target position
        list.scrollTo({ left: targetScrollLeft, behavior: 'smooth' })
      }

      var targets = links.map(function(a){ var id = a.getAttribute('data-anchor'); return id ? document.getElementById(id) : null }).filter(Boolean)
      function getDocTop(el){ try { var r = el.getBoundingClientRect(); return r.top + window.pageYOffset } catch(e){ return 0 } }

      function recomputeActiveByScroll(){
        if (lockTargetId) { setActive(lockTargetId); return }
        if (!targets.length) { setActive(null); return }
        var viewport = window.innerHeight || document.documentElement.clientHeight || 0
        var lineY = window.scrollY + stickyTop + Math.min(viewport * 0.25, 200)
        // sort defensively (in case DOM order changes)
        var ordered = targets.slice().sort(function(a,b){ return getDocTop(a) - getDocTop(b) })
        var current = null
        for (var i=0;i<ordered.length;i++){
          if (getDocTop(ordered[i]) <= lineY) current = ordered[i]; else break
        }
        // If near the very bottom, force last as active
        var scrollBottom = window.scrollY + viewport
        var docHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
        if (!current && (docHeight - scrollBottom) <= 2) current = ordered[ordered.length - 1]
        if (current) setActive(current.id); else setActive(null)
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){ if (!lockTargetId && entry.isIntersecting) setActive(entry.target.id) })
        }, { root: null, rootMargin: '0px 0px -60% 0px', threshold: 0.1 })
        targets.forEach(function(t){ io.observe(t) })
        // Always reconcile by scroll position to handle the zone above first target
        on(window, 'scroll', recomputeActiveByScroll)
        on(window, 'resize', recomputeActiveByScroll)
        recomputeActiveByScroll()
      } else {
        var ticking = false
        function onScroll(){
          if (ticking) return; ticking = true
          requestAnimationFrame(function(){
            recomputeActiveByScroll()
            ticking = false
          })
        }
        on(window, 'scroll', onScroll)
        on(window, 'resize', onScroll)
        onScroll()
      }

      // scroll arrows
      var list = nav.querySelector('.v-anchor-navigation__list')
      var prevBtn = nav.querySelector('[data-arrow="prev"]')
      var nextBtn = nav.querySelector('[data-arrow="next"]')
      if (list && prevBtn && nextBtn) {
        function updateArrows(){
          try {
            var canScrollLeft = list.scrollLeft > 0
            var canScrollRight = Math.ceil(list.scrollLeft + list.clientWidth) < list.scrollWidth
            var hasOverflow = list.scrollWidth > list.clientWidth
            prevBtn.hidden = !canScrollLeft
            nextBtn.hidden = !canScrollRight
            nav.classList.toggle('has-scroll-arrows', (canScrollLeft || canScrollRight))
            list.classList.toggle('has-overflow', hasOverflow)
            
            // Reset scroll position to start when overflow is detected and centered
            if (hasOverflow && list.scrollLeft === 0 && getComputedStyle(list).justifyContent === 'center') {
              setTimeout(function() { list.scrollLeft = 0 }, 0)
            }
          } catch(e) {}
        }
        function scrollByAmount(dir){
          var amount = Math.max(120, Math.floor(list.clientWidth * 0.6))
          var to = dir === 'next' ? (list.scrollLeft + amount) : (list.scrollLeft - amount)
          list.scrollTo({ left: to, behavior: 'smooth' })
        }
        prevBtn.addEventListener('click', function(){ scrollByAmount('prev') })
        nextBtn.addEventListener('click', function(){ scrollByAmount('next') })
        list.addEventListener('scroll', updateArrows, { passive: true })
        window.addEventListener('resize', updateArrows)
        // Initial check and ensure proper scroll position
        setTimeout(function() {
          updateArrows()
          // Force scroll to start if has overflow and centered
          if (list.scrollWidth > list.clientWidth) {
            list.scrollLeft = 0
          }
        }, 0)
      }

      // initial hash
      if (location.hash && location.hash.length > 1){
        var initialId = location.hash.slice(1)
        setTimeout(function(){ 
          scrollToId(initialId, stickyTop)
          setActive(initialId)
        }, 0)
      }

      // back/forward
      window.addEventListener('popstate', function(){
        var id = (location.hash || '').replace(/^#/, '')
        if (!id) return
        scrollToId(id, stickyTop)
        setActive(id)
      })
    })
  }

  function onReady(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn() }
  onReady(function(){ try { initAnchorNav(document) } catch(e){} })

  if (window.Shopify && Shopify.designMode){
    document.addEventListener('shopify:section:load', function(e){
      try {
        if (!e || !e.detail || !e.detail.sectionId) return
        var root = document.getElementById('shopify-section-' + e.detail.sectionId)
        if (root) initAnchorNav(root)
      } catch(err){}
    })
  }
})()